import React, { useState } from "react";
import usePortfolioStore from "../../../store/builders/usePortfolioStore";

const PortfolioTile = () => {
  const { uploadPortfolioImage, isUploading } = usePortfolioStore();
  const [images, setImages] = useState([]);
  const maxFileSize = 5 * 1024 * 1024; // 5 MB
  const acceptedFormats = ["image/jpeg", "image/png", "image/webp", "image/jpg"];
  const maxUploads = 25;

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    uploadImages(files);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    uploadImages(files);
  };

  const uploadImages = (files) => {
    const validFiles = files.filter(
      (file) =>
        acceptedFormats.includes(file.type) &&
        file.size <= maxFileSize &&
        images.length < maxUploads
    );

    if (validFiles.length + images.length > maxUploads) {
      alert(`You can upload up to ${maxUploads} images only.`);
    }

    const newImages = validFiles.map((file) => ({
      url: URL.createObjectURL(file),
      file,
      description: "",
    }));

    setImages((prev) => [...prev, ...newImages]);
  };

  const handleRemoveImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleUpload = () => {
    images.forEach((image) => {
      uploadPortfolioImage(image.file, image.description);
    });
    setImages([]);
  };

  return (
    <div className="p-3 flex flex-col items-center justify-center">
      {/* Upload Area */}
      <div
        className="w-full max-w-md p-4 border-2 border-dashed border-gray-300 rounded-md bg-white flex flex-col items-center justify-center"
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
      >
        <div className="text-center">
          <div className="text-blue-500 text-2xl mb-1 flex justify-center"><img src="/assets/document.svg" alt="document icon" /></div>
          <h3 className="text-base font-medium mb-1">Upload your Image</h3>
          <p className="text-xs text-gray-500 mb-2">
            Drag and Drop image here or {" "}
            <label className="text-blue-500 underline cursor-pointer">
              <input
                type="file"
                accept="image/jpeg, image/png, image/webp, image/jpg"
                multiple
                className="hidden"
                onChange={handleFileChange}
              />
              upload here
            </label>
          </p>
          <p className="text-xs text-gray-500">
            Accepted Formats: JPG, JPEG, PNG, WEBP <br />
            Max File Size: 5 MB <br />
            <strong>Upload Limit: Up to {maxUploads} images at a time</strong>
          </p>
        </div>
      </div>

      {/* Uploaded Images */}
      {images.length > 0 && (
        <div className="mt-4 grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-6 gap-2">
          {images.map((image, index) => (
            <div
              key={index}
              className="relative w-16 h-16 bg-gray-100 rounded-md overflow-hidden"
            >
              <img
                src={image.url}
                alt="uploaded"
                className="w-full h-full object-cover"
              />
              <button
                className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs"
                onClick={() => handleRemoveImage(index)}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Upload Button */}
      {images.length > 0 && (
        <button
          className="mt-4 px-4 py-1.5 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600"
          onClick={handleUpload}
          disabled={isUploading}
        >
          {isUploading ? "Uploading..." : "Upload"}
        </button>
      )}
    </div>
  );
};

export default PortfolioTile;
